module.exports = __webpack_public_path__ + "img/transactions.b2de0f8f.png";